import $ from "jquery";
import { BaseVerifyIdentityComponent, VerifyIdentityConfig } from "./BaseVerifyIdentityComponent";
import { requestLoginCode, verifyLoginCode } from "../../requests/post";
import { getUrlParam } from "../../toolkit";

/**
 * Component for OAuth verification (Crumb Vet app login).
 * Handles authentication in webview with OAuth redirect.
 */
export class OAuthVerifyComponent extends BaseVerifyIdentityComponent {
    public static selector: string = "oauth-verify-component";
    private nonce: string | null = null;

    public init(): void {
        super.init();

        // Get nonce from URL parameters - required for OAuth flow
        this.nonce = getUrlParam("nonce");

        if (!this.nonce) {
            this.showError("Invalid authentication request. Missing required security parameter.");
            // Disable the component to prevent further interaction
            this.componentElement.find("input").prop("disabled", true);
            this.componentElement.find("button").prop("disabled", true);
        }
    }

    protected getConfig(): Partial<VerifyIdentityConfig> {
        return {
            autoAdvance: true,
            inputMode: "individual", // Now uses individual inputs like others
            onSendCode: (email: string) => requestLoginCode(email),
            onVerifyCode: (email: string, code: string) => verifyLoginCode(email, code, this.nonce),
            onResendCode: (email: string) => requestLoginCode(email)
        };
    }

    protected handleVerifySuccess(response: any): void {
        // OAuth flow requires a redirect URL in the response
        if (response.url) {
            window.location.href = response.url;
        } else {
            console.error("No OAuth redirect URL received");
            this.showError("Authentication failed. Please try again.");
        }
    }

    protected handleVerifyError(error: any): void {
        let errorMessage = "Invalid code. Please try again.";

        if (error.responseJSON) {
            if (error.responseJSON.code === "expired") {
                errorMessage = "Code expired. Please request a new one.";
            } else if (error.responseJSON.error) {
                errorMessage = error.responseJSON.error;
            } else if (error.responseJSON.message) {
                errorMessage = error.responseJSON.message;
            }
        }

        this.showError(errorMessage);
    }

    protected handleBack(): void {
        // Show the email form again
        this.componentElement.parent().hide();
        $("[data-login-form]").show();
    }
}
